// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata
// place holder for future assets
export default []
